import { GraphqlApi, IGraphqlApi } from "@/framework/network/gql/GraphqlApi";
import { UpdateUserSettingsDocument, UpdateUserSettingsMutation } from "@/framework/network/gql/generated/graphql";
import { err, ok, Result } from "neverthrow";
import GraphqlApiError from "@/framework/network/gql/GraphqlApiError";
import { GeneralResult, GeneralResultSchema } from "@/framework/objects/GeneralResult";

export class SettingsService {
  private _graphql: IGraphqlApi;

  public constructor(graphql: IGraphqlApi = new GraphqlApi()) {
    this._graphql = graphql;
  }

  async updateUserSetting(params: {}): Promise<Result<GeneralResult, GraphqlApiError>> {
    const res = await this._graphql.runMutationAndValidate<UpdateUserSettingsMutation, GeneralResult>(
      UpdateUserSettingsDocument,
      GeneralResultSchema,
      params
    );
    if (res.isErr()) {
      return err(res.error);
    } else {
      return ok(res.value);
    }
  }
}
